import Theme from "./theme.json";


const logoAsset = require("./assets/logo_voceqpad_Prancheta_1_1x (1) (1).svg");
Theme.logoImage = typeof logoAsset === "string" ? logoAsset : logoAsset.default;
export const THEME = Theme;
export const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://www.voceqpad.com.br/backoffice.api/api/v1/";
export const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID || 5;
// ⚠️ CREDENCIAL REMOVIDA DO CÓDIGO — agora vem exclusivamente do .env
export const LOGIN_AUTH_TOKEN = process.env.REACT_APP_LOGIN_AUTH_TOKEN || "";
export const LOGROCKET = process.env.REACT_APP_LOGROCKET || "false";
// ⚠️ PROJETO LOGROCKET REMOVIDO DO CÓDIGO — agora vem do .env
export const LOGROCKET_PROJECT = process.env.REACT_APP_LOGROCKET_PROJECT || "";
// ⚠️ SENTRY DSN REMOVIDO DO CÓDIGO — agora vem do .env
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
